export default function (props: any) {
    return (
        <svg viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h30v30H0z" />
                <path
                    d="M21.809 20.98c.266.315.254.607-.037.874a.54.54 0 0 1-.4.146.594.594 0 0 1-.435-.182l-3.852-3.901c-1.018.826-2.193 1.24-3.525 1.24-1.55 0-2.865-.548-3.943-1.641C8.54 16.422 8 15.109 8 13.578c0-1.531.539-2.844 1.617-3.937C10.695 8.547 12.01 8 13.56 8c1.55 0 2.865.547 3.943 1.64 1.078 1.094 1.617 2.407 1.617 3.938 0 1.313-.4 2.467-1.2 3.464l3.889 3.937zM10.47 16.676c.848.85 1.878 1.276 3.089 1.276s2.24-.425 3.089-1.276c.848-.85 1.272-1.884 1.272-3.099 0-1.215-.424-2.248-1.272-3.099-.848-.85-1.878-1.276-3.09-1.276-1.21 0-2.24.425-3.088 1.276-.848.85-1.272 1.884-1.272 3.1 0 1.214.424 2.247 1.272 3.098z"
                    fill="#666"
                />
            </g>
        </svg>
    );
}
